export default __webpack_public_path__ + "static/media/BOHATER.2eeb853a.png";